/* ============================================================================
 * Lavora Bags — Varyant Galeri Filtresi (Mio teması için)
 * ----------------------------------------------------------------------------
 * Ne yapar: Ürün sayfasında bir renk seçilince, galeride SADECE o rengin
 *           fotoğraflarını gösterir, diğer renklerin fotoğraflarını gizler.
 *
 * Nasıl çalışır: Her görselin alt metni = renk adı (Siyah, Kahve, Krem...).
 *               Seçili renk radio/select'ten okunur, alt metni eşleşmeyen
 *               slaytlar gizlenir, Swiper yeniden hesaplanır.
 *
 * Kurulum: Bu dosyayı temaya "assets/lavora-variant-gallery.js" olarak ekle,
 *          sonra product şablonuna şu satırı ekle (bir kez):
 *          <script src="{{ 'lavora-variant-gallery.js' | asset_url }}" defer></script>
 *
 * Not: Konsola [Lavora] önekiyle log basar. Sorun olursa konsol çıktısını paylaş.
 * ==========================================================================*/
(function () {
  'use strict';

  var LOG = '[Lavora]';
  var HIDDEN = 'lv-hidden';

  // Gizleme için CSS'i bir kez enjekte et
  function injectStyle() {
    if (document.getElementById('lv-variant-gallery-style')) return;
    var s = document.createElement('style');
    s.id = 'lv-variant-gallery-style';
    s.textContent = '.' + HIDDEN + '{display:none !important;}';
    document.head.appendChild(s);
  }

  // Bir metni normalize et (küçük harf + boşluk kırp + Türkçe İ/ı toleransı)
  function norm(v) {
    return (v || '')
      .toString()
      .trim()
      .toLocaleLowerCase('tr-TR');
  }

  // Bir ürün bölümü içindeki galeriyi kur
  function initSection(root) {
    if (!root || root.__lvGalleryInit) return;

    // Ana galeri slaytları (küçük resim slaytları hariç)
    var mainSlides = Array.prototype.slice.call(
      root.querySelectorAll('.product-media__slider-slide.js-product-media-item')
    );
    if (!mainSlides.length) return; // bu bölümde galeri yok

    // Her slaydın alt metni (renk)
    var alts = mainSlides.map(function (slide) {
      var img = slide.querySelector('img.product-media__image, img');
      return norm(img && img.getAttribute('alt'));
    });

    // Küçük resim slaytları (alt karusel) — ana slaytlarla aynı sırada
    var thumbs = Array.prototype.slice.call(
      root.querySelectorAll('.product-media__slider-thumbnails .product-media__slider-thumbnails-slide')
    );

    // Renk option'ını otomatik tespit et:
    // Seçicideki değerleri, galeri alt metinleriyle en çok kesişen option = renk option'ı
    var altSet = {};
    alts.forEach(function (a) { if (a) altSet[a] = true; });

    var pickers = collectPickers(root); // [{name, valuesSet, getSelected}]
    var colorPicker = null;
    var bestOverlap = 0;
    pickers.forEach(function (p) {
      var overlap = 0;
      Object.keys(p.valuesSet).forEach(function (v) { if (altSet[v]) overlap++; });
      if (overlap > bestOverlap) { bestOverlap = overlap; colorPicker = p; }
    });

    if (!colorPicker) {
      console.log(LOG, 'Renk option bulunamadı (alt metinlerle eşleşen seçici yok). Galeri filtresi pasif.');
      return;
    }
    root.__lvGalleryInit = true;
    console.log(LOG, 'Renk option:', colorPicker.name, '| galeri slaytı:', mainSlides.length);

    // Renk değerleri kümesi (ortak/renk-dışı görselleri ayırmak için)
    var colorValues = colorPicker.valuesSet;

    function apply() {
      var selected = norm(colorPicker.getSelected());
      if (!selected) return;

      mainSlides.forEach(function (slide, i) {
        var alt = alts[i];
        var isColorImage = !!colorValues[alt];      // alt gerçekten bir renk mi
        var show = !isColorImage || alt === selected; // renk değilse ortak görsel → hep göster
        slide.classList.toggle(HIDDEN, !show);
        if (thumbs[i]) thumbs[i].classList.toggle(HIDDEN, !show);
      });

      // Swiper'ları güncelle
      updateSwiper(root.querySelector('.product-media__slider'), mainSlides);
      updateSwiper(root.querySelector('.product-media__slider-thumbnails'), thumbs);

      console.log(LOG, 'Seçili renk:', selected);
    }

    // Renk değişimini dinle (radio + select, bubbling)
    root.addEventListener('change', function (e) {
      var t = e.target;
      if (t && (t.matches('input[data-option]') || t.matches('select[data-option]'))) {
        apply();
      }
    });

    // İlk yükleme — Swiper geç başlayabilir, birkaç kez dene
    apply();
    setTimeout(apply, 300);
    setTimeout(apply, 1000);
  }

  // Seçicileri topla: radio grupları ve select'ler
  function collectPickers(root) {
    var map = {}; // name -> picker

    // Radio grupları
    root.querySelectorAll('input[type="radio"][data-option]').forEach(function (input) {
      var name = input.getAttribute('data-option');
      if (!map[name]) {
        map[name] = {
          name: name,
          type: 'radio',
          valuesSet: {},
          inputs: [],
          getSelected: null
        };
      }
      map[name].valuesSet[norm(input.value)] = true;
      map[name].inputs.push(input);
    });
    Object.keys(map).forEach(function (name) {
      if (map[name].type === 'radio') {
        map[name].getSelected = function () {
          var checked = this.inputs.filter(function (i) { return i.checked; })[0];
          return checked ? checked.value : '';
        };
      }
    });

    // Select'ler
    root.querySelectorAll('select[data-option]').forEach(function (sel) {
      var name = sel.getAttribute('data-option');
      var p = {
        name: name,
        type: 'select',
        valuesSet: {},
        el: sel,
        getSelected: function () { return this.el.value; }
      };
      Array.prototype.slice.call(sel.options).forEach(function (o) {
        p.valuesSet[norm(o.value)] = true;
      });
      // Aynı isimde radio yoksa ekle
      if (!map[name]) map[name] = p;
    });

    return Object.keys(map).map(function (k) { return map[k]; });
  }

  // Swiper örneğini bulup güncelle, ilk görünür slayta git
  function updateSwiper(sliderEl, slides) {
    if (!sliderEl || !sliderEl.swiper) return;
    var sw = sliderEl.swiper;
    try {
      sw.update();
      var firstVisible = -1;
      for (var i = 0; i < slides.length; i++) {
        if (!slides[i].classList.contains(HIDDEN)) { firstVisible = i; break; }
      }
      if (firstVisible >= 0) sw.slideTo(firstVisible, 0);
      sw.update();
    } catch (e) {
      console.log(LOG, 'Swiper update hatası:', e);
    }
  }

  function initAll() {
    injectStyle();
    var containers = document.querySelectorAll('.js-product-media-container');
    if (!containers.length) return;
    containers.forEach(function (c) {
      var root = c.closest('.shopify-section') || c.parentElement || document;
      initSection(root);
    });
  }

  // Başlat
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Tema editörü / dinamik yüklemeler için
  document.addEventListener('shopify:section:load', initAll);
  window.addEventListener('load', initAll);
})();
